export class VariantVerificationModel {
    _id: string;
    variantId: string;
    designBaseId: string;
    verificationId: string;
    methodId: string;
    Fx_p: number;
    Fx_m: number;
    Fy_p: number;
    Fy_m: number;
    Fz_p: number;
    Fz_m: number;
    Mx_p: number;
    Mx_m: number;
    My_p: number;
    My_m: number;
    Mz_p: number;
    Mz_m: number;
    Vrd: number;

    constructor(
        variantId,
        designBaseId,
        id = '',
        verificationId = '',
        methodId = '',
        Fx_p = null,
        Fx_m = null,
        Fy_p = null,
        Fy_m = null,
        Fz_p = null,
        Fz_m = null,
        Mx_p = null,
        Mx_m = null,
        My_p = null,
        My_m = null,
        Mz_p = null,
        Mz_m = null,
        Vrd = null,
        ) {
            this._id = id;
            this.variantId = variantId;
            this.designBaseId = designBaseId;
            this.verificationId = verificationId;
            this.methodId = methodId;
            this.Fx_p = Fx_p;
            this.Fx_m = Fx_m;
            this.Fy_p = Fy_p;
            this.Fy_m = Fy_m;
            this.Fz_p = Fz_p;
            this.Fz_m = Fz_m;
            this.Mx_p = Mx_p;
            this.Mx_m = Mx_m;
            this.My_p = My_p;
            this.My_m = My_m;
            this.Mz_p = Mz_p;
            this.Mz_m = Mz_m;
            this.Vrd = Vrd;
    }
}
